// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1ZAfZ","label":"Labeled_label__33Y27","divider":"Labeled_divider__1Llsj"};